export const woundTypesDefault = {
  //Wound Types
  abrasion: "Abrasion/Bruise",
  arterial: "Arterial",
  blister: "Blister (Bullae)",
  burn: "Burn",
  cancerLesion: "Cancer Lesion",
  diabetic: "Diabetic",
  hSuppurtiva: "Hidradenitis Suppurativa",
  laceration: "Laceration",
  masd: "Moisture Associated Skin Damage (MASD)",
  mole: "Mole",
  lesion: "Open Lesion",
  pressureUlcer: "Pressure",
  rash: "Rash",
  skinTear: "Skin Tear",
  surgical: "Surgical",
  venous: "Venous",
  undiagnosed: "Undiagnosed",

  //Sub Types
  ////Burn
  first: "First Degree",
  second: "Second Degree",
  third: "Third Degree",
  fourth: "Fourth Degree",

  ////Pressure Ulcer
  one: "Stage 1",
  two: "Stage 2",
  three: "Stage 3",
  four: "Stage 4",
  dti: "Deep Tissue Injury",
  mucosalMembrane: "Mucosal Membrane",
  unstageable: "Unstageable",

  //////(Pressure Ulcer) Unstageable
  necrosis: "Slough and/or eschar",
  dressing: "Non-removable device/dressing",

  ////Skin Tear
  category1Linear: "Category I: Linear",
  category1Flap: "Category I: Flap",
  category2below25: "Category II: < 25% loss",
  category2above25: "Category II: > 25% loss",
  category3complete: "Category III: Complete loss",

  ////Surgical
  surgicalClosure: "Surgical Closure Method",
  surgicalOther: "Other",

  //////Surgical Closure Method
  closureSutures: "Sutures",
  closureStaples: "Staples",
  closureTape: "Tape",
  closureSteriStrips: "Steri-Strips",
  closureTissueAdhesives: "Tissue Adhesives",

  //////(Surgical) Other
  incisionApprox: "Incision Approximated",
  dehiscence: "Dehiscence",
  healingRidge: "Healing Ridge",

  ////Applies to all notSet keys
  notSet: "Not Set"
};
